import axios from 'axios';
import { config } from '../environment';

const URL = config.url.API_URL;

export const signatureLogin = async (walletAddress, signature, message) => {
    return await axios.post(URL + '/v1/user/login', {
        walletAddress: walletAddress,
        signature: signature,
        message: message,
    });
};

export const creditBalance = async (token) => {
    return await axios.get(URL + '/v1/user/balance', {
        headers: { Authorization: `Bearer ${token}` },
    });
};

export const gameDetails = async (gameName) => {
    return await axios.get(URL + '/v1/game', {
        params: { slug: `${gameName}` },
    });
};

export const LeaderBoardDetails = async (gameId) => {
    return await axios.post(URL + `/v1/game/leaderboard/${gameId}`);
};

export const myScore = async (gameId, token) => {
    return await axios.post(
        URL + `/v1/game/my_score/${gameId}`,
        {},
        {
            headers: { Authorization: `Bearer ${token}` },
        }
    );
};

export const prizePool = async (gameId) => {
    return await axios.post(URL + `/v1/game/prize/` + gameId);
};

export const gameRank = async (gameId, token) => {
    return await axios.post(
        URL + `/v1/game/my_rank/${gameId}`,
        {},
        {
            headers: { Authorization: `Bearer ${token}` },
        }
    );
};
